import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';
import { SaveUsuarioSistema } from '../../shared';

export type CreateUsuarioSistemaPageProps = {};

const CreateUsuarioSistemaPage: React.FC<
  CreateUsuarioSistemaPageProps
> = () => {
  useCheckPermissions(PermissionsEnum.auth_add_user);

  return <SaveUsuarioSistema title="Crear Usuario" />;
};

export default CreateUsuarioSistemaPage;
